import React from 'react'
import Topheader from '../../components/Topheader'
import style from './styles.module.css'
export default function Rewardpoints() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Mga Puntos ng Gantimpala" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    T. Ano ang Reward Points?
                </div>
                <div className={style.sub_text3}>
                    Ang Reward Points ay ang in-game na pera na natatamo mo sa pamamagitan ng paglalaro, pagkapanalo sa mga torneo, at pag-abot ng mataas na ranggo sa leaderboard. Maaari mong i-redeem ang mga ito sa Baazi Store para sa mga eksklusibong alok at gift cards.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    T. Ano ang maaari kong bilhin gamit ang Reward Points?
                </div>
                <div className={style.sub_text3}>
                    Ang Reward Points ay maaaring i-redeem sa Baazi Store para makuha ang mga kahanga-hangang gantimpala na available sa kasalukuyan. Regular na may idinaragdag na bagong gantimpala, patuloy na bumalik at suriin.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>T. Kailangan ko bang gumastos ng pera para makakuha ng Reward Points?</div>
                <div className={style.sub_text3}>Hindi. Gamitin lang nang matalino ang iyong Free Chips. Maglaro, makipagtunggali, at kumita ng mga puntos. Walang bayad na kailangan.</div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>T. May expiration ba ang Reward Points?</div>
                <div className={style.sub_text3}>Hindi agad, ngunit ang mga hindi nagagamit na puntos ay maaaring ma-reset sa panahon ng season refresh cycles. Manatiling aktibo para mapatuloy ang pag-akyat at pag-redeem.</div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>T. May buwanang limitasyon ba sa mga redemption?</div>
                <div className={style.sub_text3}>Oo, maaari kang gumawa ng maximum na 15 redemption bawat buwan gamit ang iyong Reward Points.</div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>T. Maaari bang i-convert ang Reward Points sa pera?</div>
                <div className={style.sub_text3}>Hindi. Ang Reward Points ay maaari lamang gamitin para mag-redeem ng mga gantimpala sa Baazi Store.</div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>T. Hindi naidagdag ang aking Reward Points. Ano ang gagawin ko?</div>
                <div className={style.sub_text3}>
                    I-refresh ang app o mag-log out at mag-log in ulit. Kung nananatili ang problema, makipag-ugnayan sa amin sa <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> kasama ang iyong username at mga detalye ng gameplay.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>T. Na-redeem ko na ang aking Reward Points ngunit hindi ko natanggap ang item.</div>
                <div className={style.sub_text3}>
                    Mangyaring maghintay ng hanggang 48 oras para sa pagpoproseso. Kung hindi pa natanggap, makipag-ugnayan sa amin sa <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> kasama ang pangalan ng iyong piniling gantimpala at petsa ng redemption para sa tulong.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text3}>Para sa mas detalyadong mga FAQ, bisitahin ang seksyon ng Reward Points sa loob ng app.</div>

            </div>
        </div>
    )
}
